import { createStore } from "solid-js/store";
import type { MetricSnapshot, MetricSource, ServiceHealth } from "@houston/shared";

/**
 * Central metric store. Each source writes its latest snapshot here.
 * Components read via fine-grained SolidJS reactivity — only the
 * specific bound DOM nodes update when a value changes.
 */
type MetricsState = {
  latest: Record<string, MetricSnapshot | undefined>;
  health: Partial<Record<MetricSource, ServiceHealth>>;
};

const [metrics, setMetrics] = createStore<MetricsState>({
  latest: {},
  health: {},
});

export function recordMetric(snap: MetricSnapshot) {
  setMetrics("latest", `${snap.source}:${snap.metric}`, snap);
}

export function recordHealth(h: ServiceHealth) {
  setMetrics("health", h.source, h);
}

export { metrics };
